import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ExpenseResponse } from 'src/app/models/expense.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { EditCategoryVendorRequest } from 'src/app/models/vendor.model';
import { ExpenseService } from 'src/app/services/expense.service';
import { VendorService } from 'src/app/services/vendor.service';
import { Router } from '@angular/router';
import { PermissionTypeEnum } from "src/app/common/permission-enum";
import { GlobalStateService } from 'src/app/services/global-state.service';
import { FiscalDocumentService } from 'src/app/services/fiscal-document.service';
import { DestinationService } from 'src/app/services/destination.service';
import { switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { OrderReservationService } from 'src/app/services/order-reservation.service';

@Component({
  selector: 'app-history-docs',
  templateUrl: './history-docs.component.html',
  styleUrls: ['./history-docs.component.scss']
})
export class HistoryDocsComponent implements OnInit {
  creating = false;
  expenses: ExpenseResponse[] = []
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  search = "";
  startDate = '';
  endDate = '';
  isAscendent = 0;
  providers: { [key: number]: any } = {};
  editing: { [key: number]: InputAutocompleteModel } = {};
  buttonEditCategory: ButtonLoading = new ButtonLoading("btn-success", false, "", "fa-save");
  deleting: { [key: number]: any } = {};
  toDelete = null;
  reason = "";
  questionForModal = null;
  assigningForModal = null;
  assigningWarehouseForModal = null;
  total = 0;
  detailing: { [key: string]: boolean } = {};
  appliesPP: { [key: string]: boolean } = {};
  applyExpense: { [key: number]: boolean } = {};
  moving: { [key: string]: boolean } = {};
  assigning: { [key: string]: boolean } = {};
  assigningWarehouse: { [key: string]: boolean } = {};

  invoiceDetail: any = null;
  permissionType = PermissionTypeEnum;

  toggleModal = false;
  toggleModalPP = false;
  showModalAssign = false;
  currentDoc: ExpenseResponse = null;
  currentDocId: number = null;
  currentExpense: ExpenseResponse = null;
  currentExpenseForWarehouse: ExpenseResponse = null;
  warehouses: any[] = [];
  filterWarehouses: any[] = [];

  inputWarehouse: InputAutocompleteModel = new InputAutocompleteModel(
    "",
    false,
    true,
    "Selecciona una bodega",
    "fa-warehouse",
    "danger",
    "danger",
    null,
    []
  );

  constructor(
    private expenseService: ExpenseService,
    private toastService: ToastrService,
    private vendorService: VendorService,
    private destinationService: DestinationService,
    private globalState: GlobalStateService,
    private router: Router,
    private fiscalDocumentService: FiscalDocumentService,
    private reservationService: OrderReservationService,
  ) {
    var today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.startDate = today.toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getProviders();
    this.getWarehouses();
  }

  getWarehouses() {
    this.destinationService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        this.inputWarehouse.total = this.warehouses;
        this.inputWarehouse.filterElements = this.warehouses;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al cargar bodegas");
      }
    });
  }

  getProviders() {
    this.vendorService.getProvidesByClue('').subscribe({
      next: (response: ResponseObject) => {
        //this.expenses = response.data;
        response.data.forEach(element => {
          this.providers[element.id] = element;
        });
        this.getExpenses();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getExpenses() {
    this.expenseService.getDocuments(DateUtil.parseDateToMilliseconds(this.startDate), DateUtil.parseDateToMilliseconds(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        this.total = 0;
        this.expenses = response.data;
        this.expenses.forEach((expense) => {
          this.total += expense.total*(expense.currency==0? 1 : expense.exchangeRate);
          expense.vendorName = (this.providers[expense.vendorId]) ? this.providers[expense.vendorId].name : 'Sin nombre proveedor';
        })
        this.expenses = this.expenses.sort((a, b) => {
          if (b.date !== a.date) {
            return b.date - a.date;
          } else {
            return b.id - a.id;
          }
        });
        
        this.pagination.total = this.expenses;
        
        this.resetPagination();
        this.searching();
        this.getExpensesInfo();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  showModalOption(expense) {
    this.toDelete = expense;
  }

  deleteExpense() {
    if (this.deleting[this.toDelete.id]) {
      return;
    }
    this.deleting[this.toDelete.id] = true;
    var temp = this.toDelete;
    this.toDelete = null;
    this.vendorService.deleteExpense(temp.documentId, this.reason).subscribe({
      next: (response: ResponseObject) => {
        this.deleting[temp.id] = false;
        this.reason = "";
        this.toastService.success("Gasto eliminado correctamente!");
        this.getExpenses();
      },
      error: (error: HttpErrorResponse) => {
        this.deleting[temp.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  searching() {
    this.total = 0;
    this.pagination.total = this.expenses.filter((expense) => {
      const valueReturn = this.matchValue(expense, this.search);
      if (valueReturn) {
        this.total += expense.total*(expense.currency==0? 1 : expense.exchangeRate);
      }
      return valueReturn;
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  matchValue(element, value: any) {
    return element.nit.toLowerCase() == value.toLowerCase() ||
      element.series.toLowerCase() == value.toLowerCase() ||
      element.number == value ||
      element.category.toLowerCase().includes(value.toLowerCase()) ||
      element.balance == value ||
      element.vendorName?.toLowerCase().includes(value.toLowerCase());
  }

  checkDateValue() {
    if (this.startDate && this.endDate) {
      this.getExpenses();
    }
  }

  editCategory(expense) {
    if (this.editing[expense.id]) {
      return;
    }
    var added: { [key: number]: any } = {}
    this.vendorService.getCategoriesVendor(expense.vendorId).subscribe({
      next: (response: ResponseObject) => {
        this.editing[expense.id] = new InputAutocompleteModel(expense.category, true, true, "", "fa-circle-check", "danger", "danger", null, response.data);
        response.data.forEach(detail => {
          added[detail.id] = detail;
        });
        this.vendorService.getAllCategoriesVendor().subscribe({
          next: (response: ResponseObject) => {
            response.data.forEach(detail => {
              added[detail.id] = detail;
            });
            var temp = Object.values(added);
            this.editing[expense.id].total = temp;
            this.editing[expense.id].filterElements = temp;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
        //this.editing[expense.id].total = response.data;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeCategory(input: InputAutocompleteModel) {
    input.filterElements = input.total.filter((category) => {
      return category.name.toLowerCase().includes(input.value.toLowerCase())
    })
    input.verified = false;
    input.data = null;
    if (input.filterElements.length == 0) {
      input.class = "fa-circle-plus text-info";
      input.bgColor = "for-info";
      return;
    }
    input.class = "fa-list";
  }

  selectCategory(category, input: InputAutocompleteModel) {
    input.value = category.name;
    input.class = "fa-circle-check";
    input.verified = true;
    input.data = category;
  }

  tempCategory: { input: any, categoryName: any, expense: any } = null;

  updateCategory(expense, categoryName) {
    if (this.buttonEditCategory.loading) {
      return;
    }
    var input: InputAutocompleteModel = this.editing[expense.id];
    if (input.value != categoryName) {
      if (input.data) {
        this.updateCategoryVendor(input, categoryName, expense)
      } else {
        this.questionForModal = "Se creará la categoría " + input.value;
        this.tempCategory = { input: input, categoryName: categoryName, expense: expense };
      }
    } else {
      this.buttonEditCategory.loading = false;
      delete this.editing[expense.id];
    }
  }

  updateCategoryVendor(input, categoryName, expense) {
    var newRequest = new EditCategoryVendorRequest();
    newRequest = input.data;
    this.buttonEditCategory.loading = true;
    this.vendorService.editDoc(expense.vendorId, expense.id, [newRequest]).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha editado correctamente la categoria!");
        delete this.editing[expense.id];
        this.questionForModal = "";
        this.buttonEditCategory.loading = false;
        this.getExpenses();
      },
      error: (error: HttpErrorResponse) => {
        this.buttonEditCategory.loading = false;
        this.toastService.error(error.error.message);
      }
    })

  }

  closeCreateCategory(option) {
    if (option == OptionsModalEnum.ACCEPT) {
      this.saveCategory();
    } else {
      this.tempCategory = null;
      this.questionForModal = "";
    }
  }

  saveCategory() {
    this.vendorService.createCategoryVendor(this.tempCategory.input.value).subscribe({
      next: (response: ResponseObject) => {
        var newCategory = response.data as EditCategoryVendorRequest;
        this.tempCategory.input.data = newCategory;
        this.updateCategoryVendor(this.tempCategory.input, this.tempCategory.categoryName, this.tempCategory.expense);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  detailingInvoice(invoice) {
    if (this.detailing[invoice.id]) {
      return;
    }
    this.detailing[invoice.id] = true;
    this.toggleModal = true;
    this.currentDoc = invoice;
    this.currentDocId = invoice.documentId;
  }


  movingToWarehouse(invoice) {
    this.expenseService.setTranslateTempPPE(invoice.documentId).subscribe({
      next: (response: ResponseObject) => {
        if (response.data) {
          this.globalState.setIsTranslate(true);
          this.router.navigateByUrl('/dashboard/ppe-submit');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Este documento no se puedo trasladar", "Error")
      }
    });
    // this.expenseService.getDetailDocument(invoice.id).subscribe({
    //   next: (response: ResponseObject) => {
    //     this.toastService.error("Gasto trasladado a ppe con exito");
    //     this.router.navigateByUrl('/dashboard/ppe-submit'); // <-- Aquí haces la redirección
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastService.error("Error al obtener el detalle del gasto" + error.error.message);
    //     this.detailing[invoice.id] = false;
    //   }
    // });
  }

  closeModal(event: any) {
    this.toggleModal = false;
    this.detailing[this.currentDoc.id] = false;
  }

  closeModalPP(event: any) {
    this.toggleModalPP = false;
    this.appliesPP[this.currentDoc.id] = false;
  }

  closeModalAssign(event: any) {
    this.assigningForModal = false;
    this.assigning[this.currentDoc.id] = false;
  }

  generateFiscalDocument(invoice: any) {
    const requestGenerateFiscalDocument = {
      idDocument: invoice.id ? invoice.id : null,
      type: 1
    }
    this.fiscalDocumentService.generateFiscalDocument(requestGenerateFiscalDocument).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Generando Documento Fiscal");
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al generar documento fiscal");
      }
    });
  }

  openApplyPP(invoice: any) {
    if (this.appliesPP[invoice.id]) {
      return;
    }
    this.appliesPP[invoice.id] = true;
    this.toggleModalPP = true;
    this.currentDoc = invoice;
    this.currentDocId = invoice.documentId;
  }

  assignDetination(invoice) {
    this.assigning[invoice.id] = true;
    this.destinationService.getDestinationExpense(invoice.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data.length > 0) {
          this.toastService.warning("Este gasto ya tiene un destino asignado");
        } else {
          this.assigningForModal = true;
          this.currentExpense = invoice;
        }
        this.assigning[invoice.id] = false;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se puede obtener la informacion del destino y gasto", "Error")
        this.assigning[invoice.id] = false;
        this.assigningForModal = false;
      }
    });
  }

  assignWarehouse(invoice) {
    this.assigningWarehouse[invoice.id] = true;
    this.destinationService.getDestinationExpense(invoice.id).subscribe({
      next: (response: ResponseObject) => {
        if (response.data.length > 0) {
          this.toastService.warning("Este gasto ya tiene un destino asignado");
        } else {
          this.assigningWarehouseForModal = true;
          this.currentExpenseForWarehouse = invoice;
        }
        this.assigningWarehouse[invoice.id] = false;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se puede obtener la informacion del destino y gasto", "Error")
        this.assigningWarehouse[invoice.id] = false;
        this.assigningWarehouseForModal = false;
      }
    });
  }

  getExpensesInfo() {
    this.pagination.total.forEach(element => {
      this.appliesPP[element.id] = true;
      this.expenseService.getExpenseDoc(element.documentId).subscribe({
        next: (response: ResponseObject) => {
          if (response.data != null && response.data.applyToPP != null) {
            this.applyExpense[element.documentId] = response.data.applyToPP;
          } else {
            this.applyExpense[element.documentId] = null;
          }
          this.appliesPP[element.id] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.appliesPP[element.id] = false;
        }
      });
    });
  }

  handleWarehouseInput(input: InputAutocompleteModel) {
    input.filterElements = this.warehouses.filter(w =>
      w.name.toLowerCase().includes(input.value.toLowerCase()) ||
      (w.id + "").includes(input.value)
    );

    input.verified = false;
    input.data = null;

    if (input.filterElements.length === 0) {
      input.class = "fa-xmark text-danger";
    } else {
      input.class = "fa-list";
    }
  }

  selectWarehouse(warehouse, input: InputAutocompleteModel) {
    input.value = warehouse.name;
    input.data = warehouse;
    input.verified = true;
    input.class = "fa-circle-check";
  }

  confirmAssignWarehouse() {
    if (!this.inputWarehouse.data?.id) {
      this.toastService.warning("Selecciona una bodega");
      return;
    }

    this.reservationService.transferProductValidation(this.inputWarehouse.data.id, new Date().toLocaleDateString('en-CA')).pipe(
      switchMap((validateRes: any) => {
        if (!validateRes.data) {
          this.toastService.error('La Bodega no tiene Destino Asignado.');
          return throwError(() => new Error("No hay destino asignado para la transferencia, por favor asigne uno antes de realizar la transferencia"));
        } else {
          return this.destinationService.assignWarehouseToExpense(
            this.currentExpenseForWarehouse.id,
            this.inputWarehouse.data.id
          );
        }
      }),
    ).subscribe({
      next: () => {
        this.toastService.success("Bodega asignada correctamente");
        this.assigningWarehouseForModal = false;
        this.getExpenses();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }
}
